<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('newApp.BasicInfo.bi') }}</span>
    </div>
    <el-form class="common_form" label-position="left" ref="basicInformationForm" :rules="rules" label-width="174px"
             :model="formData"
    >
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.an')">
            <el-input v-model="formData.activityCode" disabled />
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.fs')" prop="financialSystemName">
            <el-select v-model="formData.financialSystemName" :placeholder="$t('general.ps')"
                       :disabled="financialSystemList.length < 1"
            >
              <el-option v-for="item in financialSystemList" :key="item.comCode" :label="item.comName"
                         :value="item.comName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.toc')" prop="currencyCode">
            <el-select v-model="formData.currencyCode" :placeholder="$t('general.ps')" disabled>
              <el-option v-for="item in currencyList" :key="item.currCode" :label="item.currName"
                         :value="item.currCode"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.ct')">
            <el-input v-model="formData.unionChannelType" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.cn')">
            <el-input v-model="formData.applyUserName" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.at')">
            <el-input v-model="formData.applyTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.cs')" prop="saler">
            <el-select :disabled="readOnlyMode || (isEditable !== 0 && isEditable !== 1) || salerDisabled"
                       v-model="formData.saler" :filterable="belongToSmb" :remote="belongToSmb" reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="remoteMethod" :loading="saleLoading"
                       @change="salerChange"
            >
              <el-option v-for="item in saleList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.ci')" prop="applyUserTel">
            <el-input v-model="formData.applyUserTel" :disabled="readOnlyMode" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.hc')" prop="city">
            <el-input v-model="formData.city" :disabled="readOnlyMode" maxlength="50" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.Poa')" prop="activityGoal">
            <el-select v-model="formData.activityGoal" :disabled="readOnlyMode" :placeholder="$t('general.ps')">
              <el-option v-for="item in activityGoalList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="formData.activityGoal === $t('newApp.BasicInfo.ot')">
          <el-form-item :label="$t('newApp.BasicInfo.Oc')" prop="otherClassification">
            <el-select v-model="formData.otherClassification" :disabled="readOnlyMode" :placeholder="$t('general.ps')">
              <el-option v-for="item in otherClassificationList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.coa')" prop="activityClassificationCode">
            <el-select v-model="formData.activityClassificationCode"
                       :disabled="readOnlyMode || (isEditable !== 0 && isEditable !== 1)" :placeholder="$t('general.ps')"
                       @change="activityClassificationCodeChange"
            >
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-show="relationActivityShow">
          <!--关联活动分类名称 -->
          <el-form-item :label="relationActivityName" prop="relatedActivityCode" :required="relationActivityShow">
            <div style="display:flex">
              <el-select v-model="formData.relatedActivityCode" :disabled="readOnlyMode" :placeholder="$t('general.ps')"
                         @change="relatedActivityChange"
              >
                <el-option v-for="item in relationActivityList" :key="item.code" :label="item.text" :value="item.code" />
              </el-select>
              <el-button type="text" v-if="relationActivityName === $t('newApp.activityInfo.ta') && sourceLink" @click="downloadCommand">{{ $t('general.Download') }}</el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.noa')" prop="activityName">
            <el-input v-model="formData.activityName" maxlength="200" :disabled="readOnlyMode" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!belongToSmb || formData.targetObject">
          <el-form-item :label="$t('newApp.activityInfo.mta')" prop="targetObject">
            <el-select v-model="formData.targetObject" @change="qdMeetingSegmentClear" :disabled="readOnlyMode"
                       :placeholder="$t('general.ps')"
            >
              <el-option v-for="item in filteredTargetObjectList"
                         :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 主要目标对象-其它内容 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="isTargetObjectOther">
          <el-form-item :label="$t('newApp.activityInfo.otherTargetObject')" prop="targetObjectOther" :rules="[{ required: true, message: $t('newApp.activityInfo.otherTargetObjectP'), trigger: 'blur' }]">
            <el-input v-model="formData.targetObjectOther" :placeholder="$t('newApp.activityInfo.otherTargetObjectP')" :maxlength="200" :disabled="readOnlyMode" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="(!belongToSmb && formData.activityClassificationCode && formData.activityClassificationCode !== 'AC_03') || formData.organizer"
        >
          <el-form-item :label="$t('newApp.activityInfo.Organizer')" prop="organizer">
            <el-select v-model="formData.organizer" @change="organizerChange" :disabled="readOnlyMode"
                       :placeholder="$t('general.ps')"
            >
              <el-option v-for="item in organizerList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.foa')" prop="activityForms">
            <el-select v-model="formData.activityForms" :disabled="readOnlyMode" :placeholder="$t('general.ps')">
              <el-option v-for="item in activityFormsList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.toa')" prop="activityTypeCode">
            <el-select v-model="formData.activityTypeCode" @change="activityTypeChange" :disabled="readOnlyMode"
                       :placeholder="$t('general.ps')"
            >
              <el-option v-for="item in activityTypeList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="formData.targetObject === $t('general.Channel') && formData.activityTypeCode === '1-ver02'"
        >
          <el-form-item :label="$t('newApp.activityInfo.cms')" prop="qdMeetingSegment">
            <el-select v-model="formData.qdMeetingSegment" :disabled="readOnlyMode" :placeholder="$t('general.ps')">
              <el-option v-for="item in qdMeetingSegmentList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.tnoptbi')" prop="inviterNum">
            <el-input v-model="formData.inviterNum" :disabled="readOnlyMode" @input="inviterNumFilter" maxlength="9" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.edoh')" prop="expectStartDate">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :disabled="readOnlyMode" type="datetime"
                            :placeholder="$t('general.psad')" v-model="formData.expectStartDate" :picker-options="pickerOptions"
                            style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.eed')" prop="expectEndDate">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :disabled="readOnlyMode" type="datetime"
                            :placeholder="$t('general.psad')" v-model="formData.expectEndDate" :picker-options="pickerOptions"
                            style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!readOnlyMode && belongToQyw">
          <el-form-item :label="$t('newApp.activityInfo.IS')" prop="viewIndustryAgenda">
            <el-cascader class="viewIndustryAgendaCascader" popper-class="viewIndustryAgenda"
                         v-model="formData.viewIndustryAgenda" ref="viewIndustryAgenda" :options="industryAgendaList"
                         :props="{ multiple: true }" collapse-tags clearable
            />
          </el-form-item>
        </el-col> -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="readOnlyMode && formData.viewIndustryAgenda && formData.viewIndustryAgenda.length > 0"
        >
          <el-form-item :label="$t('newApp.activityInfo.Industry')">
            <div>{{ formData.viewIndustry }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                v-if="readOnlyMode && formData.viewIndustryAgenda && formData.viewIndustryAgenda.length > 0"
        >
          <el-form-item :label="$t('newApp.activityInfo.Bitt')" class="folding">
            <div>{{ formData.viewAgenda }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                v-if="!belongToSmb || (formData.plateView && formData.plateView.length > 0)"
        >
          <el-form-item :label="$t('newApp.activityInfo.teietcs')" class="folding" prop="plateView">
            <el-checkbox-group v-model="formData.plateView" v-if="!readOnlyMode" @change="plateOtherChange"
                               :disabled="readOnlyMode"
            >
              <el-checkbox v-for="item in plateList" :key="item.fieldKey" :label="item.fieldKey" name="plateType">
                {{
                  item.fieldValue
                }}
              </el-checkbox>
            </el-checkbox-group>
            <div v-show="plateOtherShow" v-if="!readOnlyMode">
              <el-input type="textarea" v-model="formData.plateOther" :disabled="readOnlyMode" maxlength="50" />
            </div>
            <div v-else>{{ formData.plateView.length > 0 ? formData.plateView : '' }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <ProductLineSelect
            v-if="!readOnlyMode"
            ref="productLineSelectRef"
            v-model="formData.productlineSupplement"
            :productline-supplement-list="productlineSupplementList"
            :disabled="readOnlyMode"
            :show-other-input="true"
            :productline-other.sync="formData.productlilneOther"
            :activity-code="formData.activityCode"
          />
          <el-form-item
            v-else
            :label="$t('newApp.activityInfo.artpl')"
            class="folding"
            prop="productlineSupplement"
          >
            <div>{{ formData.productlineSupplement }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="salerData.belongToQyw && lang === 'zh-CN'">
          <el-form-item :label="comscValue" class="folding" prop="communicationScenarioList">
            <template>
              <el-checkbox-group v-model="formData.communicationScenarioList" @change="productlineSupplementChange($event)">
                <el-checkbox v-for="item in fbCommunicationScenario" :key="item.fieldKey" :label="item.fieldValue" name="productlineSupplementType">{{ item.fieldValue }}</el-checkbox>
              </el-checkbox-group>
              <!-- <div v-show="productlineOtherShow">
                <el-input type="textarea" v-model="formData.productlineOther" :disabled="isReadOnly" maxlength="50" />
              </div> -->
            </template>
            <!-- <div class="custom">{{ formData.productlineView }}</div> -->
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="agendaList.length">
          <el-form-item :label="$t('newApp.activityInfo.agenda')" class="folding" prop="agendaShow">
            <template>
              <el-checkbox-group v-model="formData.agendaShow" @change="agendaListChange($event)">
                <el-checkbox v-for="item in agendaList" :key="item.fieldKey" :label="item.agenda" name="productlineSupplementType">{{ item.agenda }}</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-form-item>
        </el-col>
        <el-col v-if="lang === 'zh-CN'" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('newApp.activityInfo.ActivityBgA')" class="folding" prop="activityBackgroundPurpose">
            <template>
              <el-input
                type="textarea"
                v-model="formData.activityBackgroundPurpose"
                placeholder="需填写活动目的，背景，会议目标，会议议程"
                maxlength="1000"
                show-word-limit
              />
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { newApplicationFormApi } from '../../service';
import { bus } from '@/utils/bus.js';
import { arrRemoveDuplication, arrayQuery, isNotEmpty } from '@/utils/utils';
import targetObjectMixin from '../../mixins/targetObjectMixin';
import ProductLineSelect from './ProductLineSelect.vue';
export default {
  components: { ProductLineSelect },
  mixins: [targetObjectMixin],
  data () {
    let phoneNumberValidator = (rule, value, callback) => {
      if (value && !/^[0-9]{7,}$/.test(value)) {
        callback(new Error(this.$t('newApp.BasicInfo.pnfiw')));
      } else {
        callback();
      }
    };
    let relatedActivityCodeMessage = (rule, value, callback) => {
      if (!value && this.relationActivityShow) {
        callback(new Error(this.$t('newApp.activityInfo.pstaacn')));
      } else {
        callback();
      }
    };
    let dateValidator = (rule, value, callback) => {
      if (this.readOnlyMode) {
        callback();
        return;
      }
      if (this.formData.expectStartDate > this.formData.expectEndDate) {
        callback(new Error(this.$t('newApp.activityInfo.tsdcbgtted')));
      } else {
        this.$refs.basicInformationForm.clearValidate(['expectStartDate', 'expectEndDate']);
        callback();
      }
    };
    let productlineValidator = (rule, value, callback) => {
      if (this.productlineOtherShow && !this.formData.productlineOther) {
        callback(new Error(this.$t('newApp.activityInfo.Peacp')));
      } else {
        callback();
      }
    };
    let plateValidator = (rule, value, callback) => {
      this.$nextTick(() => {
        if (this.plateOtherShow && !this.formData.plateOther) {
          callback(new Error(this.$t('newApp.activityInfo.peteis')));
        } else {
          callback();
        }
      });
    };
    return {
      rules: {
        applyUserTel: [
          { validator: phoneNumberValidator, trigger: 'blur' }
        ],
        activityName: [
          { required: true, message: this.$t('newApp.activityInfo.peen'), trigger: 'blur' }
        ],
        activityClassificationCode: [
          { required: true, message: this.$t('newApp.activityInfo.psaac'), trigger: 'change' }
        ],
        targetObject: [
          { required: true, message: this.$t('newApp.activityInfo.pstmt'), trigger: 'change' }
        ],
        organizer: [
          { required: true, message: this.$t('newApp.activityInfo.psao'), trigger: 'change' }
        ],
        city: [
          { required: true, message: this.$t('newApp.activityInfo.pehc'), trigger: 'blur' }
        ],
        activityTypeCode: [
          { required: true, message: this.$t('newApp.activityInfo.psaet'), trigger: 'change' }
        ],
        qdMeetingSegment: [
          { required: true, message: this.$t('newApp.activityInfo.psacms'), trigger: 'change' }
        ],
        activityGoal: [
          { required: true, message: this.$t('newApp.activityInfo.Pstpote'), trigger: 'change' }
        ],
        otherClassification: [
          { required: true, message: this.$t('newApp.activityInfo.Psac'), trigger: 'change' }
        ],
        activityForms: [
          { required: true, message: this.$t('newApp.activityInfo.psaef'), trigger: 'change' }
        ],
        inviterNum: [
          { required: true, message: this.$t('newApp.activityInfo.pettnop'), trigger: 'blur' }
        ],
        expectStartDate: [
          { required: true, message: this.$t('newApp.activityInfo.psasd'), trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        expectEndDate: [
          { required: true, message: this.$t('newApp.activityInfo.psaed'), trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        financialSystemName: [
          { required: true, message: this.$t('newApp.BasicInfo.psafs'), trigger: 'change' }
        ],
        currencyCode: [
          { required: true, message: this.$t('newApp.BasicInfo.psac'), trigger: 'change' }
        ],
        saler: [
          { required: true, message: this.$t('newApp.BasicInfo.pstcs'), trigger: 'change' }
        ],
        relatedActivityCode: [
          { validator: relatedActivityCodeMessage, trigger: 'change' }
        ],
        productlineSupplement: [
          { required: true, message: this.$t('newApp.activityInfo.psapl'), trigger: 'change' },
          { validator: productlineValidator, trigger: 'change' }
        ],
        communicationScenarioList: [
          { required: true, message: `${this.$t('newApp.activityInfo.ps')}`, trigger: 'change' }
        ],
        agendaShow: [
          { required: true, message: `${this.$t('newApp.activityInfo.Psagenda')}`, trigger: 'change' }
        ],
        viewIndustryAgenda: [
          { required: true, message: this.$t('newApp.activityInfo.Psyip'), trigger: 'change' }
        ],
        plateView: [
          { required: true, message: this.$t('newApp.activityInfo.teietcs'), trigger: 'change' },
          { validator: plateValidator, trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      industryAgendaList: [], // 所属行业方案列表
      targetObjectList: [], // 主要目标对象
      organizerList: [], // 主办方
      qdMeetingSegmentList: [], // 渠道会议细分
      plateList: [], // 活动预计包含板块
      financialSystemList: [], // 财务体系列表
      currencyList: [], // 货币种类列表
      saleList: [], // 对应销售列表
      otherClassificationList: [], // 其他分类列表
      activityClassificationList: [], // 活动分类
      activityGoalList: [], // 活动目的
      activityFormsList: [], // 活动形式
      productlineSupplementList: [], // 活动内容涉及产品线
      relationActivityList: [], // 关联活动分类列表
      activityTypeList: [], // 活动类型列表
      comscValue: '',
      fbCommunicationScenario: [], // 交流场景列表
      fbCommunicationScenarioOld: [], // 原交流场景列表
      fbCommunicationScenarioNew: [], // 战略产品列表
      agendaList: [], // 活动议程列表
      sourceLink: '',
      formData: {
        plateView: [],
        productlineSupplement: [],
        viewIndustryAgenda: [],
        communicationScenarioList: [],
        mactCommunicationScenarioList: [],
        mactAgendaList: [],
        agendaShow: []
      },
      relationActivityName: this.$t('newApp.activityInfo.Aan'),
      plateOtherShow: false, // 活动预计包含板块'其他'显隐
      relationActivityShow: false,
      productlineOtherShow: false,
      readOnlyMode: false, // 只读模式
      isEditable: 0,
      salerDisabled: false,
      saleLoading: false,
      belongToSmb: false,
      belongToQyw: false,
      agendaStatus: false, // 活动议程显隐
      lang: localStorage.getItem('lang') || 'zh-CN'
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      salerData: (state) => state.newApplication.salerData
    })
  },
  methods: {
    organizerChange (val) {
      this.$set(this.formData, 'activityTypeCode', '');
      this.formData.activityType = '';
      this.activityTypeList = [];
      this.$nextTick(() => {
        this.$refs.basicInformationForm.clearValidate(['activityTypeCode']);
      });
      let params = '主办型';
      if (val === this.$t('newApp.activityInfo.atomc')) {
        params = '参与型';
      }
      this.getActivityTypeList(params);
    },
    getActivityTypeList (params) {
      newApplicationFormApi.getActivityTypeList(params).then(res => {
        if (res.status === '200') {
          this.activityTypeList = res.data;
        }
      });
    },
    activityTypeChange (val) {
      // 获取活动类型名称
      this.formData.activityType = arrayQuery(val, this.activityTypeList, 'fieldKey').fieldValue;
      // 清除相关联字段
      this.qdMeetingSegmentClear();
    },
    validateHandler () {
      return new Promise((resolve, reject) => {
        this.$refs['basicInformationForm'].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    relatedActivityChange (val) {
      let obj = arrayQuery(val, this.relationActivityList, 'code');
      this.formData.relatedActivityName = obj.text;
      // 区域模块活动不关联活动名称
      if (this.formData.activityClassificationCode !== 'AC_01') {
        let obj = arrayQuery(val, this.relationActivityList, 'code');
        this.$set(this.formData, 'activityName', obj.text);
        this.agendaStatus = false;
      } else {
        this.agendaStatus = true;
        if (val) {
          this.getTemplateActivityAgendaCommand(val);
        }
      }
    },
    downloadCommand () {
      window.open(this.sourceLink);
    },
    getTemplateActivityAgendaCommand (val) {
      const currentInfo = this.relationActivityList.find(item => item.code === val);
      if (isNotEmpty(currentInfo)) {
        this.sourceLink = currentInfo.sourceLink;
      }
      newApplicationFormApi.getTemplateActivityAgenda(val).then(res => {
        if (res.status === '200') {
          this.agendaList = res.data;
          if (!this.$route.query.activityCode) {
            this.formData.mactAgendaList = [];
            this.formData.agendaShow = [];
            res.data.forEach(item => {
              this.formData.mactAgendaList.push({
                  agendaName: item.agenda,
                  agendaCode: item.orderNum
              });
              this.formData.agendaShow.push(item.agenda);
            });
          }
        }
      });
    },
    agendaListChange (e) {
      this.formData.mactAgendaList = [];
      this.agendaList.forEach(item => {
        e.forEach(ite => {
          if (item.agenda === ite) {
            const index = this.formData.mactAgendaList.findIndex(iteIndex => iteIndex.agendaName === ite);
            if (index === -1) {
              this.formData.mactAgendaList.push({
                agendaName: item.agenda,
                agendaCode: item.orderNum
              });
            }
          }
        });
      });
    },
    plateOtherChange (val) {
      this.plateOtherShow = val.some(item => {
        return item === '10';
      });
    },
    qdMeetingSegmentClear () {
      this.$set(this.formData, 'qdMeetingSegment', '');
      if (!this.isTargetObjectOther) {
        this.$set(this.formData, 'targetObjectOther', '');
      }
      this.$nextTick(() => {
        this.$refs.basicInformationForm.clearValidate(['qdMeetingSegment']);
      });
    },
    inviterNumFilter (val) {
      let numVal = val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '');
      this.$set(this.formData, 'inviterNum', numVal);
    },
    salerChange (val, flag) {
      let salerObj = arrayQuery(val, this.saleList, 'userId');
      this.formData.salerId = salerObj.userId;// 对应销售ID
      this.formData.salerName = salerObj.userName;// 对应销售姓名
      this.formData.salerDeptCode = salerObj.deptCode;// 对应销售部门code
      this.formData.salerDeptName = salerObj.deptName;// 对应销售部门名称
      this.belongToQyw = salerObj.belongToQyw;
      this.getFinancialSystemList();
      if (flag) {
        this.$store.commit('newApplication/setSalerLoadFlag', 1);
      } else {
        this.$store.commit('newApplication/setSalerLoadFlag', 0);
      }
      this.$store.commit('newApplication/setSalerData', salerObj);
    },
    getRelevanceActivityList (val) {
      let params = 'NEW';
      // 根据值获取关联活动的列表
      if (val === 'AC_01') {
        this.agendaStatus = true;
        // 区域模板活动
        this.relationActivityName = this.$t('newApp.activityInfo.ta');
        newApplicationFormApi.getTemplateActivity(params).then(res => {
          this.relationActivityList = res.data.map(item => {
            return {
              code: item.id + '',
              text: item.templateName,
              activityType: item.activityType,
              activityTypeCode: item.activityTypeCode,
              activitySubType: item.activitySubType,
              activitySubtypeCode: item.activitySubtypeCode,
              activityGoal: item.activityGoal,
              sourceLink: item.sourceLink
            };
          });
          const currentInfo = this.relationActivityList.find(item => item.code === this.formData.relatedActivityCode);
          if (isNotEmpty(currentInfo)) {
            this.sourceLink = currentInfo.sourceLink;
          }
        });
        if (this.formData.relatedActivityCode) {
          this.getTemplateActivityAgendaCommand(this.formData.relatedActivityCode);
        }
      } else {
        this.agendaStatus = false;
        this.relationActivityShow = false;
      }
    },
    activityClassificationCodeChange (val, flag) {
      // 获取对应的活动分类名称
      this.formData.activityClassification = arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;

      this.relationActivityShow = true;
      this.$set(this.formData, 'relatedActivityCode', '');
      this.relationActivityList = [];
      this.$nextTick(() => {
        this.$refs.basicInformationForm.clearValidate(['relatedActivityCode']);
      });
      if (flag) {
        this.$store.commit('newApplication/setActivityClassificationLoadFlag', 1);
      } else {
        this.$store.commit('newApplication/setActivityClassificationLoadFlag', 0);
      }
      this.$store.commit('newApplication/setActivityClassification', val);
      if (val !== 'AC_01') {
        this.agendaList = [];
        this.formData.agendaShow = [];
        this.formData.mactAgendaList = [];
      }
      this.getRelevanceActivityList(val);
    },
    productlineSupplementChange (e) {
      const { activityCode } = this.$store.state.newApplication;
      const eventCode = this.$route.query.activityCode || activityCode;
      this.formData.mactCommunicationScenarioList = [];
      this.fbCommunicationScenario.forEach(item => {
        e.forEach(ite => {
          if (item.fieldValue === ite) {
            const index = this.formData.mactCommunicationScenarioList.findIndex(iteIndex => iteIndex.communicationScenarioName === ite);
            if (index === -1) {
              this.formData.mactCommunicationScenarioList.push({
                activityCode: eventCode,
                communicationScenarioName: item.fieldValue,
                communicationScenarioCode: item.fieldKey
              });
            }
          }
        });
      });
    },
    industryAgendaFilter () {
      let returnVal = this.formData.viewIndustryAgenda.map(item => {
        let industryObj = this.industryAgendaList.find(data => {
          return item[0] === data.value;
        });
        let result = {
          industryCode: industryObj.value,
          industryName: industryObj.label
        };

        let agendaObj = industryObj.children.find(data => {
          return item[1] === data.value;
        });
        result.agendaCode = agendaObj.value;
        result.agendaName = agendaObj.label;
        return result;
      });
      return returnVal;
    },
    productlineSupplementFilter () {
      return this.$refs.productLineSelectRef.productlineSupplementFilter();
    },
    plateFilter () {
      let returnVal = [];
      for (let i = 0; i < this.formData.plateView.length; i++) {
        this.plateList.forEach(item => {
          if (item.fieldKey === this.formData.plateView[i]) {
            returnVal.push({
              moduleCode: item.fieldKey,
              moduleName: item.fieldKey === '10' ? this.formData.plateOther : item.fieldValue
            });
          }
        });
      }
      return returnVal;
    },
    getDraftData () {
      if (this.formData.activityClassificationCode) {
        // 活动分类名称过滤
        this.formData.activityClassification = this.arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;
      }
      // 关联活动名称过滤
      if (this.formData.relatedActivityCode && isNotEmpty(this.relationActivityList)) {
        this.formData.relatedActivityName = isNotEmpty(this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code')) ? this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code').text : '';
      }
      // 活动类型名称过滤
      if (this.formData.activityTypeCode) {
        this.formData.activityType = this.arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'fieldKey').fieldValue;
      }
      // 所属行业方案过滤
      if (this.formData.viewIndustryAgenda && this.formData.viewIndustryAgenda.length > 0) {
        this.formData.industryAgenda = this.industryAgendaFilter();
      }
      // 产品线过滤
      if (this.formData.productlineSupplement.length > 1) {
        this.formData.newProductlineSupplement = this.$refs.productLineSelectRef.productlineSupplementFilter();
      }
      // 活动预计包含板块
      if (this.formData.plateView.length > 0) {
        this.formData.plate = this.plateFilter();
      }
      return this.formData;
    },
    getFormData () {
      return new Promise((resolve, reject) => {
        this.$refs['basicInformationForm'].validate((valid) => {
          if (valid) {
            this.formData.currencyType = this.formData.currencyCode;

            // 活动分类名称过滤
            this.formData.activityClassification = this.arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;
            // 关联活动名称过滤
            if (this.formData.relatedActivityCode && isNotEmpty(this.relationActivityList)) {
              this.formData.relatedActivityName = isNotEmpty(this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code')) ? this.arrayQuery(this.formData.relatedActivityCode, this.relationActivityList, 'code').text : '';
            }
            // 活动类型名称过滤
            this.formData.activityType = this.arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'fieldKey').fieldValue;
            // 所属行业方案过滤
            if (this.formData.viewIndustryAgenda && this.formData.viewIndustryAgenda.length > 0) {
              this.formData.industryAgenda = this.industryAgendaFilter();
            }
            // 产品线过滤
            if (this.formData.productlineSupplement.length > 1) {
              this.formData.newProductlineSupplement = this.$refs.productLineSelectRef.productlineSupplementFilter();
            }
            // 活动预计包含板块
            if (this.formData.plateView.length > 0) {
              this.formData.plate = this.plateFilter();
            }
            resolve(this.formData);
          } else {
            document.querySelector('.contentScrollbar>.el-scrollbar__wrap').scrollTop = 0;
            this.$message.error(this.$t('newApp.activityInfo.Tbicfta'));
          }
        });
      });
    },
    getActivityList () {
      // 活动类型--activity_type
      // 其他分类--other_classification
      // 主办方--organizer
      // 渠道会议细分--qd_meeting_segment
      // 目标对象--target_object
      // 预计板块--plate
      let params = [
        'plate', // 预计板块
        'qd_meeting_segment', // 渠道会议细分
        'organizer', // 主办方
        'target_object', // 目标对象
        'other_classification', // 其他分类
        'union_market_help',
        'activity_forms',
        'qd_activity_classification',
        'productline_supplement',
        'activity_goal',
        'expense_detail_item',
        'fb_communication_scenario',
        'smb_international_activity_type'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          let { data } = res;
          this.plateList = data.plate;
          this.qdMeetingSegmentList = data.qd_meeting_segment;
          this.organizerList = data.organizer;
          this.targetObjectList = data.target_object;
          this.otherClassificationList = data.other_classification;
          this.activityClassificationList = data.qd_activity_classification;
          this.activityGoalList = data.activity_goal;
          this.activityFormsList = data.activity_forms;
          this.productlineSupplementList = data.productline_supplement;
          this.fbCommunicationScenario = data.fbCommunicationScenario;
          this.fbCommunicationScenarioNew = data.fbCommunicationScenario.filter(item => item.flag);
          this.fbCommunicationScenarioOld = data.fbCommunicationScenario.filter(item => !item.flag);
          const { mactCommunicationScenarioList } = this.editEchoData;
          if (isNotEmpty(mactCommunicationScenarioList)) {
            const index = this.fbCommunicationScenarioNew.findIndex(item => item.fieldKey === mactCommunicationScenarioList[0].communicationScenarioCode);
            if (index !== -1) {
              this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
              this.comscValue = this.$t('newApp.activityInfo.strpr');
            } else {
              this.fbCommunicationScenario = this.fbCommunicationScenarioOld;
              this.comscValue = this.$t('newApp.activityInfo.comsc');
            }
          } else {
            this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
            this.comscValue = this.$t('newApp.activityInfo.strpr');
          }
          if (this.$route.query.activityCode) {
            // 旧活动类型过滤
            if (this.formData.activityTypeCode) {
              let activityTypeObj = arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'fieldKey');
              if (!activityTypeObj) {
                this.$set(this.formData, 'activityTypeCode', '');
                this.$set(this.formData, 'activityType', '');
              }
            }
          }
        }
      });
    },
    getActivityCode () {
      newApplicationFormApi.getActivityCode().then(res => {
        if (res.status === '200') {
          this.$set(this.formData, 'activityCode', res.data.code);
          this.$set(this.formData, 'applyTime', res.data.creatTime);
          bus.$emit('activityCode', this.formData.activityCode);
          this.$store.commit('newApplication/setActivityCode', res.data.code);
        }
      });
    },
    getCustomerList (name) {
      let params = {
        checkType: 'LIKE',
        customerName: name,
        pageSize: 1,
        pageNum: 1
      };
      newApplicationFormApi.getCustomerList(params).then(res => {
        if (res.status === '200') {
          let data = res.data && res.data.data.length > 0 ? res.data.data[0].name : '';
          this.$set(this.formData, 'channelSalerName', data);
        }
      });
    },
    remoteMethod (query) {
      if (query !== '') {
        this.saleLoading = true;
        newApplicationFormApi.getSalesmanList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.saleList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.saleList = [];
            }
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    getFinancialSystemList () {
      newApplicationFormApi.getFinancialSystemList(this.formData.salerId).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
              let defaultValFlag = res.data.some(item => {
                return item.comCode === '111';
              });
              // 如果新建申请 财务体系中没有福建 则默认第一个
              if (!defaultValFlag) {
                this.$set(this.formData, 'financialSystemCode', res.data[0].comCode);
                this.formData.financialSystemName = res.data[0].comName;
              } else {
                // 财务体系默认为福建
                this.$set(this.formData, 'financialSystemCode', '111');
                this.formData.financialSystemName = this.$t('general.fujian');
              }
          }
          this.financialSystemList = res.data;
        }
      });
    },
    getSalerData (flag) {
      newApplicationFormApi.getSalesmanList('null').then(res => {
        if (res.status === '200') {
          if (res.data && res.data.length > 0) {
            this.saleList = res.data.map(item => {
              return {
                ...item,
                combination: `${item.userName}/${item.deptName}`
              };
            });
            this.$set(this.formData, 'salerId', this.saleList[0].userId);
            this.getFinancialSystemList(this.saleList[0].userId);
            if (this.saleList.length && !this.$store.state.userInfo.belongToSmb) {
              this.salerDisabled = true;
              this.$set(this.formData, 'saler', this.saleList[0].userId);
              this.salerChange(this.saleList[0].userId, flag);
              return;
            }
            if (flag === 2 && this.formData.salerId) {
              // this.salerChange(this.formData.salerId, flag);
            }
          }
        }
      });
    },
    getIndustryAgendaList () {
      newApplicationFormApi.getIndustryAgendaList().then(res => {
        if (res.status === '200') {
          this.industryAgendaList = res.data;
        }
      });
    },
    getCurrencyList () {
      this.formData.currencyCode = 'CNY'; // 货币默认为人民币
      newApplicationFormApi.getCurrencyList().then(res => {
        if (res.status === '200') {
          this.currencyList = res.data;
          let currencyObj = arrayQuery(this.formData.currencyCode, this.currencyList, 'currCode');
          this.formData.currencyType = currencyObj.currName;
          // 货币税率过滤
          this.formData.currFromRmbRate = currencyObj.currFromRmbRate;
        }
      });
    }
  },
  mounted () {
    let userInfo = this.$store.state.userInfo;
    this.belongToSmb = this.$store.state.userInfo.belongToSmb;
    if (this.$route.query.activityCode) {
      // 编辑处理
      if (this.$store.state.newApplication.editFlag) {
        // 详情页跳转过来 可编辑控制
        this.isEditable = this.$store.state.newApplication.editFlag;
        let flag = Number(this.$store.state.newApplication.editFlag);
        if (flag === 3) {
          this.readOnlyMode = true;
        }
      }
      // 编辑回显
      this.formData = {
        ...this.formData,
        ...this.editEchoData.marketActivity
      };
      // this.formData.financialSystemName = this.$t('general.fujian');
      // this.formData.financialSystemCode = '111';
      if (this.formData.salerId) {
        this.$set(this.formData, 'saler', this.formData.salerId);
      }
      this.remoteMethod(this.formData.salerId);
      // 活动类型处理
      let activityTypeParams = '全部';
      if (this.formData.organizer) {
        activityTypeParams = this.$t('newApp.activityInfo.ht');
        if (this.formData.organizer === this.$t('newApp.activityInfo.atomc')) {
          activityTypeParams = this.$t('newApp.activityInfo.pt');
        }
      }
      this.getActivityTypeList(activityTypeParams);
      // 活动分类回显处理
      if (this.formData.activityClassificationCode) {
        this.relationActivityShow = true;
        this.getRelevanceActivityList(this.formData.activityClassificationCode, 1);
        this.$store.commit('newApplication/setActivityClassificationLoadFlag', 1);
        this.$store.commit('newApplication/setActivityClassification', this.formData.activityClassificationCode);
      }
      // 所属行业方案回显处理
      if (this.editEchoData.mactAgendaList && this.editEchoData.mactAgendaList.length > 0) {
        if (this.readOnlyMode) {
          // 详情页回显
          this.formData.viewAgenda = this.editEchoData.mactAgendaList.map(item => {
            return item.agendaName;
          }).join('，');
          let industryList = arrRemoveDuplication(this.editEchoData.mactAgendaList, 'industryCode');
          this.formData.viewIndustry = industryList.map(item => {
            return item.industryName;
          }).join('，');
        } else {
          // 编辑页回显
          // this.formData.viewIndustryAgenda = this.editEchoData.mactAgendaList.map(item => {
          //   return [item.industryCode, item.agendaCode];
          // });
        }
      }
      // 产品线回显处理
      if (this.editEchoData.mactProductLineList && this.editEchoData.mactProductLineList.length > 0) {
        if (this.readOnlyMode) {
          // 无边框的编辑回显
          let productlineSupplementList = this.editEchoData.mactProductLineList.map(item => {
            if (item.productLineName.indexOf(this.$t('general.Other')) >= 0) {
              item.productLineName = item.customProductLine;
            }
            return item.productLineName;
          });
          this.formData.productlineSupplement = productlineSupplementList.join('，');
        } else {
          // 编辑模式回显
          if (this.editEchoData.mactProductLineList && this.editEchoData.mactProductLineList.length > 0) {
            this.$nextTick(() => {
              this.$refs.productLineSelectRef.initFromEchoData(
                this.editEchoData.mactProductLineList
              );
            });
          }
        }
      }
      // 活动预计包含板块回显处理
      if (this.editEchoData.mactModuleList && this.editEchoData.mactModuleList.length > 0) {
        if (this.readOnlyMode) {
          let plateList = this.editEchoData.mactModuleList.map(item => {
            return item.moduleName;
          });
          this.formData.plateView = plateList.join('，');
        } else {
          this.formData.plateView = this.editEchoData.mactModuleList.map(item => {
            if (item.moduleCode === '10') {
              this.plateOtherShow = true;
              this.$set(this.formData, 'plateOther', item.moduleName);
            }
            return item.moduleCode;
          });
        }
      }
      if (isNotEmpty(this.editEchoData.mactCommunicationScenarioList)) {
        this.formData.communicationScenarioList = this.editEchoData.mactCommunicationScenarioList.map(item => {
          return item.communicationScenarioName;
        });
        this.$set(this.formData, 'mactCommunicationScenarioList', this.editEchoData.mactCommunicationScenarioList);
      }
      if (isNotEmpty(this.editEchoData.mactAgendaList)) {
        this.formData.agendaShow = this.editEchoData.mactAgendaList.map(item => {
          return item.agendaName;
        });
        this.$set(this.formData, 'mactAgendaList', this.editEchoData.mactAgendaList);
      }
      this.$nextTick(() => {
        this.$refs.basicInformationForm.clearValidate();
      });
    } else {
      // 新增数据初始化
      // this.formData.financialSystemName = this.$t('general.fujian');
      // this.formData.financialSystemCode = '111';
      this.getCustomerList(userInfo.sysUser.userName);

      this.$set(this.formData, 'applyUserTel', userInfo.phone);
      this.formData.applyUserId = userInfo.sysUser.userId;
      this.formData.applyUserName = userInfo.sysUser.userName;
      this.formData.applyUserDeptCode = userInfo.sysUser.deptCode;
      this.formData.applyUserDeptName = userInfo.sysUser.deptName;
      this.formData.applyUserType = userInfo.userType;
      this.formData.needOrganizer = 0;
      this.getSalerData(1);
      this.getActivityCode(); // 获取活动编号及申请时间
      this.$set(this.formData, 'unionChannelType', userInfo.partnerTypeName);
      this.getActivityTypeList('全部');
      // 渠道smb活动申请处理
      if (userInfo.belongToSmb && userInfo.userType === 'qd') {
        // 活动分类
        // this.$set(this.formData, 'activityClassificationCode', 'AC_02'); // 默认区域活动
        // this.activityClassificationCodeChange(this.formData.activityClassificationCode, 1);
        // 活动目的
        // this.$set(this.formData, 'activityGoal', '其他类'); // 默认其他类
        // 其他分类
        // this.$set(this.formData, 'otherClassification', '会费'); // 默认会费
        // 活动类型
        this.$set(this.formData, 'activityTypeCode', '1-ver02'); // 默认会议类
        this.formData.activityType = this.$t('newApp.activityInfo.TypeM');
        // 活动内容涉及产品线
        this.formData.productlineSupplement = [this.$t('newApp.activityInfo.NoRL')]; // 默认无报告环节
      }
    }
    this.getActivityList(); // 获取[活动分类,活动目的,活动形式,产品线]列表
    this.getIndustryAgendaList();
    // 获取货币种类列表
    this.getCurrencyList();
  }
};
</script>

<style lang="scss" scoped>
.basicInformation {}
</style>
